import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  label,
  checked,
  onChange,
  className = '',
  containerClassName = '',
  disabled = false,
  ...props
}) => {
  const checkboxId = React.useId();

  // Custom key handler for keyboard-only users toggling with the Space bar
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
      if (!disabled && onChange) {
        onChange({ target: { checked: !checked } });
      }
    }
  };

  return (
    <label 
      className={`flex items-center gap-3.5 cursor-pointer select-none group ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${containerClassName}`}
    >
      <div className="relative">
        <input
          id={checkboxId}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          onKeyDown={handleKeyDown}
          className="sr-only"
          {...props}
        />
        <div 
          className={`
            w-5 h-5 rounded-lg border-2 transition-all flex items-center justify-center
            group-hover:border-cyan-500
            focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2 dark:focus-within:ring-sky-400 dark:focus-within:ring-offset-slate-900
            ${checked 
              ? 'bg-cyan-600 border-cyan-600 dark:bg-cyan-500 dark:border-cyan-500' 
              : 'border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800'}
            ${className}
          `}
          aria-hidden="true"
        >
          {checked && (
            <svg 
              className="w-3.5 h-3.5 text-white" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor" 
              strokeWidth="4"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </div>
      {label && (
        <span className="text-sm font-bold text-slate-500 dark:text-slate-400 group-hover:text-slate-700 dark:group-hover:text-slate-300 transition-colors">
          {label}
        </span>
      )}
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  disabled: PropTypes.bool
};

export default Checkbox;
